import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';

@Component({
  selector: 'app-complaint-form',
  templateUrl: './complaint-form.component.html',
  styleUrls: ['./complaint-form.component.scss']
})
export class ComplaintFormComponent implements OnInit {
  dialogRef: MatDialogRef<any>;
  complaintForm: FormGroup;
  submitpayload: any;
  isOtherChecked = false;
  selectedOption: string = '';
  Course: any;
  address: any;
  city: any;
  session: any;
  state: any;
  pincode: any;
  departmentList: any;
  filterdepartmentList: any;
  statusList: any;
  filterstatusList: any;
  complaintList: any;
  StuFullName: string;
  PreFix: any;
  formattedPrn: string;
  submitButton = true;
  constructor(public umsService: UmsService,private spinner: NgxSpinnerService,
    private fb: FormBuilder,private modalPopupService: ModalpopService,
    private dialogRef2:MatDialogRef<ComplaintFormComponent>,
  ) { }
  InstuName
  RgNo
  StateCodeListC
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  showOtherTextArea = false;
  StudentPersonalId = sessionStorage.getItem('loginId');
  StuloginID = sessionStorage.getItem('StudentRGID');
  ngOnInit(): void {
    this.submitButton = true;
    this.StudentPersonalId = sessionStorage.getItem('loginId');
    this.getSecretData();
    this.stuAddDetails();
   this.getUserData(this.StuloginID);
   this.getApplyData();
    this.getDepartment();
    this.fetchStatus();
    this.getComplaintData();
    
    this.RgNo = sessionStorage.getItem('StudentRGID');
    this.transPRN(this.RgNo)
    this.complaintForm = this.fb.group({
      GrievanceTitle: new FormControl ('', [Validators.required]),
      GrievanceDescription: new FormControl ('', [Validators.required]),
      StatusCode: new FormControl ('O'),
      DepartmentID: new FormControl ('', [Validators.required]),
      PreviousAttempt: new FormControl ('', [Validators.required]),
      PreviousAttemptDetail: new FormControl (''),
      checkbox: new FormControl('', [Validators.required])
    });
  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
      this.InstuName = res.projectPharam['InstituteName']
      this.session = res.projectPharam['SnName']
    })
  }
  transPRN(RgNo){
    let RgNo1 = 99999;
this.formattedPrn = RgNo.toString().padStart(8, '0');
  }


  getUserData(id) {
    this.umsService.getUserData(id).subscribe((res) => {
      this.StuFullName =  res.data[0][0]['StuFirstName'] + ' ' + res.data[0][0]['StuMidName'] + ' ' + res.data[0][0]['StuLastName'];
      this.Number = res.data[0][0]['StuMobNumber']
    });
  }
  getApplyData(){
    this.spinner.show();
    let payload = {}
    this.Course = ''
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
       this.Course = res.data[0]['CoName'];
       this.getCourse(res.data[0])
      }
    });
  }
  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.Course
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      this.PreFix = res.data[0].CoRgPrfx
    })

  }


  stuAddDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        this.address = res.data[0]['StuAddrC'];
        this.city = res.data[0]['StuCityC'];
        this.pincode = res.data[0]['StuPinC'];
        if (res.data.length > 0) {
          this.fetchStateC(res.data[0].StuCountryC, res.data[0].StuStateC);
        }
      } else {
        this.spinner.hide();
      }
    });
  }

  fetchStateC(CountryCode, StateCode) {
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const stateData = res.data.find(state => state.StateCode === StateCode);
        if (stateData) {
          this.state = stateData.StateName;
        } 
      } 
    });
  }
  getDepartment() {
    const payload = {};
    this.umsService.getDepartment(payload).subscribe((res) => {
      if (res.status) {
        this.departmentList = res.data;
        this.filterdepartmentList = this.departmentList.slice();
      } else {
        
      }
    });
  }

  onDepartmentChange(value: string): void {
    this.showOtherTextArea = value === 'OTH'; // Show textarea if "Other" is selected
  }
  submit() {
    if (this.complaintForm.invalid) {
      this.complaintForm.get('GrievanceTitle').markAsTouched();
      this.complaintForm.get('GrievanceDescription').markAsTouched();
      this.complaintForm.get('DepartmentID').markAsTouched();
      this.complaintForm.get('PreviousAttempt').markAsTouched();
      this.complaintForm.get('checkbox').markAsTouched();
      return;
    } else {
      this.ADDComplaint();
    }

  }

  ADDComplaint() {
    this.submitpayload = this.complaintForm.value;
    let payload = {}
    payload['GrievanceTitle'] = this.submitpayload.GrievanceTitle
    payload['GrievanceDescription'] = this.submitpayload.GrievanceDescription
    payload['DepartmentID'] = this.submitpayload.DepartmentID
    payload['PreviousAttempt'] = this.submitpayload.PreviousAttempt
    payload['PreviousAttemptDetail'] = this.submitpayload.PreviousAttemptDetail
    payload['StatusCode'] = this.submitpayload.StatusCode
    payload['StuloginID'] = parseInt(sessionStorage.getItem('loginId'))
    payload['UserID'] = parseInt(sessionStorage.getItem('StudentPersonalId'))
    this.umsService.addComplaint(payload).subscribe(res => {
      this.submitButton = false;
      if(res.status){
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
           this.dialogRef2.close();
        });
      }
      else{
      }
    },
  );
  }

  onOptionChange(event: Event): void {
    const selectedOption = (event.target as HTMLInputElement).value;
    
    if (selectedOption === 'no') {
      // Clear the details field if 'no' is selected
      this.complaintForm.get('PreviousAttemptDetail').setValue('');
    }
  }

  fetchStatus() {
    const payload = {};
    payload['CdType'] = 'GS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filterstatusList = this.statusList.slice();
      } else {
       
      }
    });
  }

  getComplaintData() {
    const payload = {};
    payload['StuloginID'] = parseInt(sessionStorage.getItem('loginId'));
    this.umsService.getComplaint(payload).subscribe(res => {
      if (res.status) {
        this.complaintList = res.data;
      } else {
      }
    },
  );
  }
}
